import ReactDataGrid from '@inovua/reactdatagrid-community';
import { Center, Loader, Text, TextInput } from '@mantine/core';
import { IconLock, IconLockOpen } from '@tabler/icons-react';
import formatCurrency from '../utils/formatCurrency';

const GRVLines = ({
  grvLines = [],
  isLoading,
  editable,
  onRowUpdate,
  ...rest
}) => {
  const columns = [
    {
      name: 'LineStatus',
      header: '',
      maxWidth: 45,
      textAlign: 'center',
      render: ({ value }) => {
        if (!value) return '-';

        return (
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
            }}
            title={value === 'O' ? 'Open' : 'Closed'}>
            {value === 'O' ? (
              <IconLockOpen size={20} />
            ) : (
              <IconLock size={20} />
            )}
          </span>
        );
      },
    },
    {
      name: 'grDocEntry',
      header: 'GR #',
      maxWidth: 75,
    },
    {
      name: 'LineNum',
      header: 'Line #',
      maxWidth: 75,
      textAlign: 'center',
    },
    {
      name: 'Description',
      header: 'Description',
      defaultFlex: 2,
    },
    {
      name: 'Quantity',
      header: 'GRV Qty',
      maxWidth: 75,
      textAlign: 'center',
      render: ({ value }) => Number(value).toFixed(0),
    },

    {
      name: 'UnitPrice',
      header: 'Price',
      textAlign: 'end',
      headerAlign: 'center',
      maxWidth: 100,
      render: ({ value }) => formatCurrency(value),
    },
    {
      name: 'LineTotal',
      header: 'GRV Total',
      headerAlign: 'center',
      textAlign: 'end',
      maxWidth: 100,
      render: ({ value }) => formatCurrency(value),
    },
    {
      name: 'ReceivedQuantity',
      header: 'Rec. Qty',
      maxWidth: 75,
      textAlign: 'center',
      render: ({ value, data }) => {
        const sourceQuantity = parseFloat(data.Quantity);
        const receivedQuantity = parseFloat(value);
        let borderStyle =
          sourceQuantity !== receivedQuantity
            ? '3px solid orange'
            : '1px solid #e9ecef';

        return (
          <TextInput
            value={value ?? 0}
            styles={{
              input: {
                textAlign: 'center',
                border: borderStyle,
                borderRadius: '5px',
              },
            }}
            disabled={data.LineStatus === 'C' || !editable}
            onChange={(e) => {
              const updatedReceivedQuantity = parseFloat(e.currentTarget.value);
              if (updatedReceivedQuantity === receivedQuantity) {
                return;
              }

              const updatedRow = {
                ...data,
                ReceivedQuantity: updatedReceivedQuantity,
                ReceivedLineTotal:
                  updatedReceivedQuantity * parseFloat(data.UnitPrice),
              };

              if (updatedReceivedQuantity !== sourceQuantity) {
                borderStyle = '3px solid orange';
              }

              if (typeof onRowUpdate === 'function') {
                onRowUpdate(updatedRow, grvLines);
              }
            }}
          />
        );
      },
    },
    {
      name: 'ReceivedLineTotal',
      header: 'Rec. Total',
      headerAlign: 'center',
      textAlign: 'end',
      maxWidth: 100,
      render: ({ value, data }) => {
        const sourceLineTotal = parseFloat(data.LineTotal);
        const receivedLineTotal = parseFloat(value);

        return (
          <Text
            style={{
              fontWeight:
                sourceLineTotal !== receivedLineTotal ? 'bold' : 'normal',
              color:
                sourceLineTotal !== receivedLineTotal ? 'orange' : 'inherit',
            }}>
            {formatCurrency(value)}
          </Text>
        );
      },
    },
  ];

  if (isLoading) {
    return (
      <div {...rest}>
        <Center maw={300} h={300} m="auto">
          <Loader color="cyan" />
        </Center>
      </div>
    );
  }

  return (
    <div {...rest}>
      <ReactDataGrid
        idProperty="id"
        columns={columns}
        sortable={false}
        style={{ minHeight: 300 }}
        rowHeight="auto"
        rowClassName={({ data }) =>
          data.LineStatus === 'C' ? 'row-disabled' : ''
        }
        dataSource={grvLines}></ReactDataGrid>
    </div>
  );
};

export default GRVLines;
